export class Category {
    public __classname__: string = 'Category';

    public Id : string | null = null;

    public Name : string | null = null;   
    
    constructor(params : CategoryNamedParameters ) {
        this.Id = params.Id ?? null;
        this.Name = params.Name ?? null;
    }
}

export interface CategoryNamedParameters {
    Id? : string 
    Name? : string
}